module.exports = __webpack_public_path__ + "static/media/news_menu_whte.40baed79.svg";